import { render } from "./workshopApprovedSummary.vue?vue&type=template&id=d11669d0&scoped=true"
import script from "./workshopApprovedSummary.vue?vue&type=script&lang=js"
export * from "./workshopApprovedSummary.vue?vue&type=script&lang=js"

import "./workshopApprovedSummary.vue?vue&type=style&index=0&id=d11669d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11669d0"]])

export default __exports__